import RollingMarquee from "./RollingMarquee"
export * from "./RollingMarquee"
export default RollingMarquee
